import React, { useMemo } from 'react';
import { createContext, useContext } from 'react';

type Params = Record<string, string | undefined>;
const ParamsContext = createContext<Params>({});

export const useScopedParams = () => useContext(ParamsContext);

export const ParamsProvider = ({
  children,
  params,
}: {
  children: React.ReactNode;
  params: Params;
}) => {
  const memoParams = useMemo(
    () => params,
    [
      params.deviceId,
      params.groupId,
      params.controlUnitId,
      (params as any).merchandiseId,
    ]
  );
  return (
    <ParamsContext.Provider value={memoParams}>
      {children}
    </ParamsContext.Provider>
  );
};
